import React, { Component } from "react";
import R from "ramda";
import {reduce, groupBy } from "lodash";
import moment from 'moment';

import styled from "styled-components";

const EditIcon = styled.i`
  font-size: 12px !important;
`;

const NoticeItem = ({
  id,
  title,
  notice_category_id,
  content,
  show,
  onEdit
}) => {
  let visibleClass = show ? "show" : "hide";
  return (
    <div className={`item ${visibleClass}`}>
      <div className="title">
        {title}
        <span className="pull-right">
          <a onClick={() => onEdit(id)}>
            <EditIcon className="fa fa-pencil" />{" "}
          </a>
        </span>
      </div>
      <div className="content">{content}</div>
    </div>
  );
};

class NoticeGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0
    };
  }

  onEdit = id => {
    if (id) {
      this.props.onItemEdit(id);
    }
  };

  onTitleClicked = idx => {
    this.setState({ selectedIndex: idx });
  };

  render() {
    const { notices } = this.props;
    const { selectedIndex } = this.state;
    let view = null;
    if (notices.length > 0) {
      const start_week_date = R.prop("start_week_date", notices[0]);
      const titles = R.map(R.prop("title"))(notices);

      const titleList = titles.map((title, idx) => {
        const activeClass = idx === selectedIndex ? "active" : "";
        return (
          <li key={idx} className={`title ${activeClass}`}>
            <a onClick={e => this.onTitleClicked(idx)}>
              <span className="number-box">{idx + 1}. </span>{" "}
              <span>{title}</span>
            </a>
          </li>
        );
      });

      const noticeItems = notices.map((notice, idx) => {
        const showItem = idx === selectedIndex;
        return (
          <NoticeItem
            key={idx}
            show={showItem}
            id={notice.id}
            title={notice.title}
            notice_category_id={notice.notice_category_id}
            content={notice.content}
            onEdit={this.onEdit}
          />
        );
      });

      view = (
        <div className="notice-group clearfix">
          <div className="grouped-date">
            For week startring <span className="date">{moment(start_week_date).format("YYYY MMM DD")}</span>
          </div>
          <div>
            <div className="col-md-3">
              <ul className="titles">{titleList}</ul>
            </div>
            <div className="col-md-9">{noticeItems}</div>
          </div>
        </div>
      );
    }
    return view;
  }
}

const noticeGroupSorter = (a, b) => a.date < b.date;
const noticeItemSorter = (a, b) => moment(a.updated_at) < moment(b.updated_at);
export default class NoticesList extends Component {

  renderGroups(groups, onItemEdit) {

    let collection = reduce(groups,(results, value, key)=>{
      const record = {
        date: key,
        list: value
      }
      return [...results, record];
    }, []);

    return collection.sort(noticeGroupSorter).map(({ date, list }) =>
      <NoticeGroup key={date} notices={list.sort(noticeItemSorter)} onItemEdit={onItemEdit} />
    );
  }

  render() {
    const { notices, onItemEdit } = this.props;
    const groupedNotices = groupBy(notices, notice => notice.start_week_date);
    return (
      <div className="slb-tab-content">
        {this.renderGroups(groupedNotices, onItemEdit)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoticesList.js